import axios from 'axios'
import store from '../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization : `Bearer ${store.state.user.attributes.token}` }

function stackProgramSponsorJobDelete (pFormdata) {
    const URI = `${BASE_URL}/api/programSponsorJob/stack/stackDelete`
    return axios.post(URI, pFormdata, { headers })
}

export { stackProgramSponsorJobDelete }